import { Component, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { Sidebar } from './shared/components/sidebar/sidebar';
import { Header } from './shared/components/header/header';
import { AlertModalComponent } from './shared/components/alert-modal/alert-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Sidebar, Header, AlertModalComponent, TranslateModule, FormlyModule, FormlyBootstrapModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class App implements OnInit {
  protected readonly title = signal('avsec-portal');
  isAuthPage = signal(false);

  constructor(
    private translate: TranslateService,
    private router: Router
  ) {
    // Initialize language immediately from localStorage to ensure it's available on refresh
    const savedLanguage = localStorage.getItem('language') as 'en' | 'ar' | null;
    const currentLanguage = savedLanguage || 'en';
    this.translate.use(currentLanguage);
    document.documentElement.lang = currentLanguage;
    document.documentElement.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';

    // Check if current route is an auth page
    this.router.events.subscribe(() => {
      const isAuth = this.isAuthenticationPage();
      this.isAuthPage.set(isAuth);
    });
  }

  ngOnInit() {
    // Language initialization handled in constructor
  }

  private isAuthenticationPage(): boolean {
    const authRoutes = ['/login', '/register', '/forgot-password', '/reset-password', '/verify-email'];
    return authRoutes.some(route => this.router.url.startsWith(route));
  }
}
